var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AuthService } from './auth.service';
import { GlobalsPermissions } from '@globals/permissions.global';
import { ActivatedRoute } from '@angular/router';
import { ContractsRequests } from '@base/api/contracts/contracts.requests';
import { map, take } from 'rxjs/operators';
import { UserService } from './user.service';
import * as i0 from "@angular/core";
import * as i1 from "../../api/contracts/contracts.requests";
import * as i2 from "./auth.service";
import * as i3 from "../../globals/permissions.global";
import * as i4 from "@angular/router";
import * as i5 from "./user.service";
var PermissionsService = /** @class */ (function () {
    function PermissionsService(contractApi, authService, permissions, activeRoute, accountService) {
        this.contractApi = contractApi;
        this.authService = authService;
        this.permissions = permissions;
        this.activeRoute = activeRoute;
        this.accountService = accountService;
        this.contractId = '';
    }
    /**
     * Check permissions for account user
     */
    PermissionsService.prototype.loggedUserPermissions = function () {
        var _this = this;
        var user = this.authService.user;
        if (!user.accounts)
            return [];
        var account = user.accounts
            .find(function (x) { return _this.authService.accountId.toString() === x.accountId.toString(); });
        var permissions = account ? account.accountPermissions : [];
        return permissions;
    };
    /**
     * Check permissions
     * @param contractId contract id to be checked
     */
    PermissionsService.prototype.loggedContractPermissions = function (lookup) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (!lookup)
                            return resolve([]);
                        _this.authService.currentContract
                            .pipe(take(1), map(function (permissions) { return _this.handleContractPermissions(permissions, lookup); }))
                            .subscribe(function (permissions) { return resolve(permissions); })
                            .unsubscribe();
                    })];
            });
        });
    };
    /**
     * get list of permissions by section type, could be 'account' for
     * account level permissions or 'contract' for contract level permissions
     * @param type section permission type ['account', 'contract']
     * @param [lookup] contract section id
     */
    PermissionsService.prototype.getSectionPermissions = function (type, lookup) {
        return __awaiter(this, void 0, void 0, function () {
            var lookupData, permissions, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        lookupData = lookup;
                        if (!type)
                            return [2 /*return*/, []];
                        if (!(type === 'account')) return [3 /*break*/, 1];
                        _a = this.loggedUserPermissions();
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.loggedContractPermissions(lookupData)];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        permissions = _a;
                        return [2 /*return*/, permissions];
                }
            });
        });
    };
    /**
     * Given section and user permissions, compare if there exist an intersection between one or more items
     * @param sectionPermissions section you want to validate
     * @param userPemissions user permissions
     */
    PermissionsService.prototype.checkPermissions = function (sectionPermissions, userPemissions) {
        var _this = this;
        var allowed = false;
        if (!sectionPermissions || !userPemissions)
            return allowed;
        var permissions = [];
        var _loop_1 = function (permission) {
            var exists = userPemissions
                .find(function (_permission) {
                var item = _this.permissions[permission] || '';
                return _permission.toLowerCase() === item.toLowerCase();
            });
            if (exists)
                permissions.push(permission);
        };
        for (var _i = 0, sectionPermissions_1 = sectionPermissions; _i < sectionPermissions_1.length; _i++) {
            var permission = sectionPermissions_1[_i];
            _loop_1(permission);
        }
        allowed = permissions.length >= 1;
        return allowed;
    };
    /**
     * If permissions list is not empty return same parmissions
     * otherwise request permissions list
     * @param permissions stored permissions list
     * @param lookup rootContractId
     */
    PermissionsService.prototype.handleContractPermissions = function (permissions, lookup) {
        // if (permissions.length)
        //   return permissions;
        return this.getContractPermissions(lookup);
    };
    /**
     * Request permissions list for a contract
     * @param lookup contract id
     */
    PermissionsService.prototype.getContractPermissions = function (lookup) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.contractApi.lookup(lookup).toPromise()
                .then(function (res) {
                _this.accountService.account = res;
                var contractId = res.contract.contractId;
                return _this.contractApi.contractPermissions(contractId).toPromise();
            })
                .then(function (permissions) {
                _this.authService.contract = permissions['data'];
                resolve(permissions['data'] || []);
            })
                .catch(function (err) { return resolve([]); });
        });
    };
    PermissionsService.ngInjectableDef = i0.defineInjectable({ factory: function PermissionsService_Factory() { return new PermissionsService(i0.inject(i1.ContractsRequests), i0.inject(i2.AuthService), i0.inject(i3.GlobalsPermissions), i0.inject(i4.ActivatedRoute), i0.inject(i5.UserService)); }, token: PermissionsService, providedIn: "root" });
    return PermissionsService;
}());
export { PermissionsService };
